import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import ReactDatepicker from "react-datepicker";
import { documentPropType } from "custom-prop-types";
import { isValidValue } from "utils/validators";

export const DateCellFormatter = ({
  accountId,
  document,
  isFocused,
  onUpdateInlineDocument,
  value
}) => {
  if (isFocused) {
    const datepickerValue = value ? moment(value) : moment();
    return (
      <ReactDatepicker
        dateFormat={ ["DD/MM/YYYY", "DD/MM/YY", "D/M/YY", "D/M/YYYY"] }
        isClearable={ false }
        onChange={ (e) => onUpdateInlineDocument({ accountId, document, field: "issued", value: e.utc().format() }) }
        placeholderText={ "Select a date..." }
        selected={ datepickerValue }
      />
    );
  }
  return <SimpleDateCellFormatter value={ value } />;
};

DateCellFormatter.defaultProps = {
  value: null
};

DateCellFormatter.propTypes = {
  accountId: PropTypes.string.isRequired,
  document: documentPropType.isRequired,
  isFocused: PropTypes.bool.isRequired,
  onUpdateInlineDocument: PropTypes.func.isRequired,
  value: PropTypes.string
};

export const SimpleDateCellFormatter = ({ value }) => {
  if (!isValidValue(value)) {
    return <span />;
  }
  return (
    <span title={ moment(value).fromNow() }>{moment(value).format("DD/MM/YY")}</span>
  );
};

SimpleDateCellFormatter.defaultProps = {
  value: null
};

SimpleDateCellFormatter.propTypes = {
  value: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/date-cell-formatter.jsx